import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Constants } from '../helpers';
import { CoatingSystemModel } from '../models';
import { BaseService } from './base.service';

@Injectable()
export class CoatingSystemService extends BaseService<CoatingSystemModel> {
	constructor(httpClient: HttpClient) {
		super(httpClient, Constants.END_POINTS.coatingSystem, CoatingSystemModel);
	}
}
